/* eslint-disable */
import { IStore } from '../store';

export const selectTheme = (store: IStore) => store.theme;
